import { render } from "./Header6.vue?vue&type=template&id=f267099a"
import script from "./Header6.vue?vue&type=script&lang=js"
export * from "./Header6.vue?vue&type=script&lang=js"

import "./Header6.vue?vue&type=style&index=0&id=f267099a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__